export enum FormType {
  CREATE = 'create',
  EDIT = 'edit',
  VALIDATE = 'validate',
}
